// extracted by mini-css-extract-plugin
export default {"errorHeader":"XO_Ivj5U6A2kQQYCJ8LM__errorHeader___","errorDesc":"xfX13L_DwCT5ClctjbQ2__errorDesc___"};